import { MAX_VALUE_AMOUNT, MIN_VALUE_AMOUNT } from '@/components/constants';
import { TReceivedInvoiceCondition } from '@/context/services/invoice/type';
import { useTranslation } from '@/i18n';
import {
  FormInputNumber,
  InputNumberProps,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from './AmountRange.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  control: Control<TReceivedInvoiceCondition>;
  size?: 'small' | 'middle' | 'large';
};

export const AmountRange: FC<Props> = memo(({ control, size }) => {
  const { t } = useTranslation();
  const inputProps: InputNumberProps = useMemo(
    () => ({
      format: 'price_with_empty',
      max: MAX_VALUE_AMOUNT,
      min: MIN_VALUE_AMOUNT,
      stringMode: true,
      ...(size ? { size } : {}),
    }),
    [size]
  );

  return (
    <div className={cx(styles['container'])}>
      <label className={cx(styles['label'])}>
        {t('received_invoice_total_amount')}
      </label>
      <div className={cx(styles['inputWrapper'])}>
        <FormInputNumber<TReceivedInvoiceCondition>
          control={control}
          name='total_amount_from'
          inputId='total-amount-from'
          inputProps={inputProps}
          testId='total-amount-from'
        />
        <span className={cx(styles['separator'])}>~</span>
        <FormInputNumber<TReceivedInvoiceCondition>
          control={control}
          name='total_amount_to'
          inputId='total-amount-to'
          inputProps={inputProps}
          testId='total-amount-to'
        />
      </div>
    </div>
  );
});
AmountRange.displayName = 'AmountRange';
